import { useCallback } from "react";
import { useDeleteLayer } from "../../../../hooks/layer/useDeleteLayer";
import { cancelTask } from "../../../../resources/scheduler";
import { useDialogReset } from "../../../../hooks/useDialogs";

type ImportCancelInput = {
  importInProgress: boolean;
  importDone: boolean;
  taskId?: string;
  targetLayerName: string;
  targetTableName?: string;
};

export const useImportCancel = ({
  importInProgress,
  importDone,
  taskId,
  targetLayerName,
  targetTableName,
}: ImportCancelInput) => {
  const [cancel] = cancelTask.use();
  const resetDialog = useDialogReset();
  const { deleteLayerFromCatalog, deleteLayerFromProject } = useDeleteLayer();

  return useCallback(async () => {
    try {
      if (importInProgress && taskId) {
        await cancel({ input: taskId });
      }
      if (importDone || importInProgress) {
        await deleteLayerFromCatalog(targetLayerName, targetTableName);
        await deleteLayerFromProject(targetLayerName);
      }
    } finally {
      resetDialog();
    }
  }, [importInProgress, importDone, taskId, deleteLayerFromProject, targetLayerName, targetTableName]);
};
